















import usePermissions from '@/composables/usePermissions'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'created-by',
  props: {
    createdBy: {
      type: Object,
      required: false
    }
  },
  setup () {
    const { can } = usePermissions()

    return {
      can
    }
  }
})
